/*
 MIT License http://www.opensource.org/licenses/mit-license.php
 Author Tobias Koppers @sokra
 */

"use strict";

const LogType = Object.freeze({
  error: /** @type {"error"} */"error",
  // message, c style arguments
  warn: /** @type {"warn"} */"warn",
  // message, c style arguments
  info: /** @type {"info"} */"info",
  // message, c style arguments
  log: /** @type {"log"} */"log",
  // message, c style arguments
  debug: /** @type {"debug"} */"debug",
  // message, c style arguments

  trace: /** @type {"trace"} */"trace",
  // no arguments

  group: /** @type {"group"} */"group",
  // [label]
  groupCollapsed: /** @type {"groupCollapsed"} */"groupCollapsed",
  // [label]
  groupEnd: /** @type {"groupEnd"} */"groupEnd",
  // [label]

  profile: /** @type {"profile"} */"profile",
  // [profileName]
  profileEnd: /** @type {"profileEnd"} */"profileEnd",
  // [profileName]

  time: /** @type {"time"} */"time",
  // name, time as [seconds, nanoseconds]

  clear: /** @type {"clear"} */"clear",
  // no arguments
  status: /** @type {"status"} */"status" // message, arguments
});

exports.LogType = LogType;

/** @typedef {typeof LogType[keyof typeof LogType]} LogTypeEnum */

const LOG_SYMBOL = Symbol("webpack logger raw log method");
const TIMERS_SYMBOL = Symbol("webpack logger times");
class WebpackLogger {
  /**
   * @param {function(LogTypeEnum, any[]=): void} log log function
   */
  constructor(log) {
    this[LOG_SYMBOL] = log;
  }
  error() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    this[LOG_SYMBOL](LogType.error, args);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    this[LOG_SYMBOL](LogType.warn, args);
  }
  info() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    this[LOG_SYMBOL](LogType.info, args);
  }
  log() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    this[LOG_SYMBOL](LogType.log, args);
  }
  debug() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }
    this[LOG_SYMBOL](LogType.debug, args);
  }
  assert(assertion) {
    if (!assertion) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      this[LOG_SYMBOL](LogType.error, args);
    }
  }
  trace() {
    this[LOG_SYMBOL](LogType.trace, ["Trace"]);
  }
  clear() {
    this[LOG_SYMBOL](LogType.clear);
  }
  status() {
    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }
    this[LOG_SYMBOL](LogType.status, args);
  }
  group() {
    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }
    this[LOG_SYMBOL](LogType.group, args);
  }
  groupCollapsed() {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }
    this[LOG_SYMBOL](LogType.groupCollapsed, args);
  }
  groupEnd() {
    for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
      args[_key10] = arguments[_key10];
    }
    this[LOG_SYMBOL](LogType.groupEnd, args);
  }
  profile(label) {
    this[LOG_SYMBOL](LogType.profile, [label]);
  }
  profileEnd(label) {
    this[LOG_SYMBOL](LogType.profileEnd, [label]);
  }
  time(label) {
    this[TIMERS_SYMBOL] = this[TIMERS_SYMBOL] || new Map();
    this[TIMERS_SYMBOL].set(label, process.hrtime());
  }
  timeLog(label) {
    const prev = this[TIMERS_SYMBOL] && this[TIMERS_SYMBOL].get(label);
    if (!prev) {
      throw new Error(`No such label '${label}' for WebpackLogger.timeLog()`);
    }
    const time = process.hrtime(prev);
    this[LOG_SYMBOL](LogType.time, [label, ...time]);
  }
  timeEnd(label) {
    const prev = this[TIMERS_SYMBOL] && this[TIMERS_SYMBOL].get(label);
    if (!prev) {
      throw new Error(`No such label '${label}' for WebpackLogger.timeEnd()`);
    }
    const time = process.hrtime(prev);
    this[TIMERS_SYMBOL].delete(label);
    this[LOG_SYMBOL](LogType.time, [label, ...time]);
  }
}
exports.Logger = WebpackLogger;